import { injectable } from 'inversify'

/**
 * Wraps the document-level effects the app applies to the page shell —
 * currently just the root element's class list, which is how the theme reaches
 * every component through the shell-* CSS tokens (invariant 8: all browser APIs
 * behind a gateway).
 *
 * ThemePresenter called `document.documentElement.classList.toggle` directly.
 * It worked under jsdom by accident, which is exactly why it survived: the test
 * asserted against the real global instead of an observable seam.
 */
@injectable()
export class DocumentGateway {
  setRootClass(className: string, enabled: boolean): void {
    document.documentElement.classList.toggle(className, enabled)
  }

  hasRootClass(className: string): boolean {
    return document.documentElement.classList.contains(className)
  }

  setTitle(title: string): void {
    document.title = title
  }

  getTitle(): string {
    return document.title
  }

  // The <html lang> attribute. Set from the active locale (I18nRepository) so a
  // screen reader uses the right phonemes — index.html ships a static `lang="en"`
  // that is only ever right for one of the two locales.
  setLang(lang: string): void {
    document.documentElement.lang = lang
  }

  getLang(): string {
    return document.documentElement.lang
  }
}
